// Review Mappings Table Column Configuration
// This file contains the column definitions for different file types

// Column types
export const COLUMN_TYPE = {
  MANDATORY: "mandatory",
  RECOMMENDED: "recommended",
};

// JE (Journal Entry) columns configuration
export const JE_COLUMNS = [
  { id: "jeNumber", name: "JE Number", type: COLUMN_TYPE.MANDATORY },
  { id: "glAccountNumber", name: "GL Account Number", type: COLUMN_TYPE.MANDATORY },
  { id: "functionalAmount", name: "Functional Amount", type: COLUMN_TYPE.MANDATORY },
  { id: "effectiveDate", name: "Effective Date", type: COLUMN_TYPE.MANDATORY },
  { id: "period", name: "Period", type: COLUMN_TYPE.MANDATORY },
];

// TB (Trial Balance) columns configuration
export const TB_COLUMNS = [
  { id: "glAccountNumber", name: "GL Account Number", type: COLUMN_TYPE.MANDATORY },
  { id: "functionalBeginningBalance", name: "Functional Beginning Balance", type: COLUMN_TYPE.MANDATORY },
  { id: "functionalEndingBalance", name: "Functional Ending Balance", type: COLUMN_TYPE.MANDATORY },
];

// COA (Chart of Accounts) columns configuration
export const COA_COLUMNS = [
  { id: "glAccountNumber", name: "GL Account Number", type: COLUMN_TYPE.MANDATORY },
  { id: "glAccountName", name: "GL Account Name", type: COLUMN_TYPE.MANDATORY },
  { id: "accountType", name: "Account Type", type: COLUMN_TYPE.MANDATORY },
  { id: "accountClass", name: "Account Class", type: COLUMN_TYPE.MANDATORY },
];

// File type to columns mapping
export const FILE_TYPE_COLUMNS = {
  "Journal Entry (JE)": JE_COLUMNS,
  "Trial Balance (TB)": TB_COLUMNS,
  "Chart of Accounts (COA)": COA_COLUMNS,
};

// Get columns for a specific file type
export const getColumnsForFileType = (fileType) => {
  return FILE_TYPE_COLUMNS[fileType] || [];
};

// Check if a column is mandatory
export const isMandatory = (column) => {
  return column.type === COLUMN_TYPE.MANDATORY;
};

// Default dropdown options for mapping
export const DEFAULT_MAPPING_OPTIONS = ["---"];

export default {
  COLUMN_TYPE,
  JE_COLUMNS,
  TB_COLUMNS,
  COA_COLUMNS,
  FILE_TYPE_COLUMNS,
  getColumnsForFileType,
  isMandatory,
  DEFAULT_MAPPING_OPTIONS,
};
